import React from "react"
import styled from "styled-components"
import appstore from "../../images/appstore.png"
import { Container, Section } from "../global"
import google from "../../images/google.png"

const GetStarted = () => (
  <StyledSection>
    <GetStartedContainer>
      <GetStartedTitle>Ready? Make today Day One ☀️</GetStartedTitle>
      <GetStartedSubtitle>
        Your intentions, your streak, your people — and a little Bitcoin for
        showing up.
      </GetStartedSubtitle>
      <Badges>
        <a href="https://apps.apple.com/us/app/day-the-dailyness-app/id1555873146">
          <img src={appstore} alt="Download on the App Store" />
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.perfectdayreactnative">
          <img src={google} alt="Get it on Google Play" />
        </a>
      </Badges>
    </GetStartedContainer>
  </StyledSection>
)

export default GetStarted

const StyledSection = styled(Section)`
  background: linear-gradient(160deg, #fff8ec 0%, #ffe3b8 100%);
  clip-path: polygon(0 5vw, 100% 0, 100% 100%, 0% 100%);
`

const GetStartedContainer = styled(Container)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 80px 0 40px;
`

const GetStartedTitle = styled.h3`
  margin: 0 auto 16px;
  text-align: center;
  color: ${(props) => props.theme.color.primary};
`

const GetStartedSubtitle = styled.p`
  margin: 0 auto 32px;
  text-align: center;
  max-width: 480px;
  color: ${(props) => props.theme.color.black.light};
  font-size: 17px;
  line-height: 26px;
`

const Badges = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  a img {
    height: 52px;
    width: auto;
    display: block;
    transition: transform 0.15s ease;
  }

  a:hover img {
    transform: translateY(-2px);
  }
`
